<template>
  <Content>
    <div class="modern-table-card p-4">
      <!-- HEADER -->
      <div
        class="table-header d-flex align-items-center justify-content-between mb-4"
      >
        <h3 class="table-title mb-0">{{ currentLang.title }}</h3>
        <button class="btn btn-primary create-btn" @click="openModal('create', null)">
          <i class="bi bi-plus-lg"></i> {{ currentLang.btnAdd }}
        </button>
      </div>

      <!-- LOADING / ERROR -->
      <div v-if="loading" class="text-center py-5"> {{ currentLang.loading }}</div>
      <div v-if="errorMessage" class="alert alert-danger">
        {{ errorMessage }}
      </div>

      <!-- TREE START -->
      <div v-if="!loading" class="tree-container">
        <!-- اینجا کامپوننت آیتم را صدا می‌زنیم و لیست اصلی را به آن می‌دهیم -->
         <CategoryItem 
        v-for="item in categories" 
        :key="item.id" 
        :item="item" 
        @refresh="fetchCategories"
        @edit="openModal('edit', $event)" 
        @add-child="openModal('create', $event)" 
      />

        <div v-if="categories.length === 0" class="text-center py-5 text-muted">
         {{ currentLang.empty }}
        </div>
      </div>
    </div>

    <!-- مدال که اینجا تعریف شده (یک بار برای کل صفحه) -->
  <CategoryModal 
      v-model="isModalOpen"
      :mode="modalMode"
      :target-item="selectedItem"
      @refresh="fetchCategories"
    />
  </Content>
</template>

<script setup>
import { ref, onMounted ,computed} from "vue";
import Content from "@/components/AdminContent.vue";
import CategoryItem from "@/components/CategoryTreeItem.vue"; // فایل دوم را اینجا ایمپورت می‌کنیم
import api from "@/plugins/axios";
import CategoryModal from "@/components/CategoryModal.vue"; // این کامپوننت را بسازید
import { showLoading, hideLoading } from "@/stores/loading";

import { lang } from "@/plugins/lang";
import enText from "@/locales/en/categoryPage";
import faText from "@/locales/fa/categoryPage";
const translations = {
  en: enText,
  fa: faText,
};
const currentLang = computed(() => translations[lang.value]);


const isModalOpen = ref(false);
const modalMode = ref("create"); // 'create' یا 'edit'
const selectedItem = ref(null); // آیتمی که قراره ویرایش یا زیرمجموعه‌اش اضافه شه

const openModal = (mode, item) => {
  modalMode.value = mode;
  selectedItem.value = item;
  isModalOpen.value = true;
};
const categories = ref([]);
const loading = ref(false);
const errorMessage = ref("");

const fetchCategories = async () => {
  loading.value = true;
  showLoading();

  try {
    const response = await api.get("/admin/categories");
    // با توجه به ریسپانسیوی که فرستادی: response.data.data
    categories.value = response.data.data;
  } catch (error) {
    errorMessage.value = "خطا در دریافت اطلاعات";
  } finally {
    loading.value = false;
    hideLoading();

  }
};

onMounted(fetchCategories);
</script>

<style scoped>
.tree-container {
  background: #fff;
  border-radius: 12px;
  padding: 10px;
}


.create-btn {
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  background: #ffffff;
  color: #334155;
  font-weight: 600;
  transition: 0.2s ease;

  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.08);
}

.create-btn:hover {
  background: #f8fafc;
  color: #0f172a;

  transform: translateY(-1px);

  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.12);
}
</style>
